var prodcat = prodcat || {};
prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.productOverviewV1 = {
    isMobile: false,
    unisonDependent: true,
    unisonReady: false,
    selectors: {
      ingredientsTab: '.js-product-overview--ingredients',
      ingredients: '.js-sku-ingredients',
      ingredientsNumber: '.js-sku-ingredients-number',
      ingredientsCta: '.js-open-sku-ingredients',
      accordionLabel: '.js-product-overview--label',
      accordionContent: '.js-product-overview--content',
      sppLayout: '.js-spp-product-layout-v2',
      productOverviewWrapper: '.js-product-overview-wrapper',
      productOverviewRightCol: '.js-prod-overview-right-col',
      ProductOverviewDesc: '.js-product-overview-desc',
      descReadMore: '.js-desc-read-more',
      sppContent: '.js-spp-content',
      skuNotes: '.js-product-overview--sku-notes',
      skuNotesTab: '.js-product-overview--sku-notes-tab'
    },
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }

      // if Unison is not ready on attach, it triggers change on initialization
      if (!!Unison.fetch.now()) {
        self.unisonReady = true;
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPMediumUp = parseInt(Unison.fetch.all()['usn-medium'], 10);
        self.isMobile = currentBpWidth <= bPMediumUp;
      }

      Unison.on('change', function () {
        if (!self.attached && self.unisonDependent) {
          // re attach on unisonReady, the initial attach was return
          self.attach(context);
        }
      });

      if (!self.unisonReady && self.unisonDependent) {
        return;
      }

      self.attached = true;
      var $overview = $('.js-product-overview', context);

      $overview.each(function () {
        var $this = $(this);

        self.getDom($this, context);
        self.setTheme($this);
        self.setEvents($this);
        self.setSelectedSku($this);
        self.expandDesc($this);
      });
    },

    getDom: function ($that, context) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$sppContent = $(self.selectors.sppContent, context);
      $that.nodes.$ingredientsTab = $(self.selectors.ingredientsTab, $that);
      $that.nodes.$ingredients = $(self.selectors.ingredients, $that);
      $that.nodes.$ingredientsCta = $(self.selectors.ingredientsCta, $that);
      $that.nodes.$ingredientsNumber = $(self.selectors.ingredientsNumber, $that);
      $that.nodes.$accordionLabel = $(self.selectors.accordionLabel, $that);
      $that.nodes.$accordionContent = $(self.selectors.accordionContent, $that);
      $that.nodes.$sppLayout = $(self.selectors.sppLayout, context);
      $that.nodes.$productOverviewWrapper = $(self.selectors.productOverviewWrapper, context);
      $that.nodes.$productOverviewRightCol = $(self.selectors.productOverviewRightCol, $that);
      $that.nodes.$ProductOverviewDesc = $(self.selectors.ProductOverviewDesc, $that);
      $that.nodes.$descReadMore = $(self.selectors.descReadMore, $that);
      $that.nodes.$skuNotes = $(self.selectors.skuNotes, $that);
      $that.nodes.$skuNotesTab = $(self.selectors.skuNotesTab, $that);
    },

    setTheme: function ($that) {
      var bgColor = $that.nodes.$sppLayout.data('productOverviewBgColor') || '#fafafa';
      var textColor = $that.nodes.$sppLayout.data('productOverviewTextColor') || '#000000';

      $that.nodes.$productOverviewWrapper.css({ 'background-color': bgColor, color: textColor });
      $that.nodes.$productOverviewRightCol.children('li').css('border-color', textColor + '4d');
      $that.nodes.$productOverviewRightCol.find('svg').css('fill', textColor);
    },

    setEvents: function ($that) {
      var self = this;
      $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
        if (!$(this).hasClass('js-spp-content')) {
          // only update when the main product sku's are changed
          return;
        }
        // Updated overview data
        var skuData = prodcat.data.getSku(skuBaseId);
        self.updateOverviewData($that, skuData);
      });

      $that.nodes.$accordionLabel.once().on('click', function (e, isFirstTimeTrigger) {
        var $this = $(this);
        var isAccordionClosed = $this.attr('aria-expanded') === 'false';

        if (isAccordionClosed) {
          // We close all first, if the clicked one is not already opened.
          $that.nodes.$accordionLabel.attr('aria-expanded', 'false');
          $that.nodes.$accordionContent.attr('aria-hidden', 'true').addClass('hidden');
        }

        $this.attr('aria-expanded', isAccordionClosed.toString());
        $this
          .next($that.nodes.$accordionContent)
          .attr('aria-hidden', !isAccordionClosed.toString())
          .toggleClass('hidden', !isAccordionClosed);
        /* The scrollTop Animation shouldn't happen when the triggered accordion is already open
           and when its triggered for the first time when the page loads. */
        if (isAccordionClosed && !isFirstTimeTrigger) {
          $('body, html').animate({
            scrollTop: $this.offset().top
          }, 200);
        }
      });
      // Trigger the First accordion when the page loads.
      $that.nodes.$accordionLabel.first().trigger('click', [true]);
    },

    setSelectedSku: function ($that) {
      var self = this;
      var preloadedSkuId = $that.nodes.$productOverviewRightCol.data('skuBaseId');
      var selectedSkuId = $that.nodes.$sppContent.data('skuBaseId');
      var skuData = {};
      if (preloadedSkuId !== selectedSkuId) {
        skuData = prodcat.data.getSku(selectedSkuId);
        self.updateOverviewData($that, skuData);
      }
    },

    updateOverviewData: function ($that, skuData) {
      var ilnListings = '';
      var ilnNumber = '';
      var skuNotes = '';
      if (!!skuData && !!skuData.ILN_LISTING) {
        ilnListings = skuData.ILN_LISTING;
      }
      if (!!skuData && !!skuData.ILN_NUMBER) {
        ilnNumber = skuData.ILN_NUMBER;
      }
      if (!!skuData && !!skuData.SKU_NOTES) {
        skuNotes = skuData.SKU_NOTES;
      }
      $that.nodes.$ingredients.html(ilnListings);
      $that.nodes.$ingredientsNumber.html(ilnNumber);
      $that.nodes.$skuNotes.html(skuNotes);

      if (!ilnListings && !ilnNumber) {
        $that.nodes.$ingredientsTab.addClass('hidden');
      } else {
        $that.nodes.$ingredientsTab.removeClass('hidden');
      }
      skuNotes ? $that.nodes.$skuNotesTab.removeClass('hidden') : $that.nodes.$skuNotesTab.addClass('hidden');
      $that.nodes.$productOverviewRightCol.data('skuBaseId', skuData.SKU_BASE_ID);
    },

    expandDesc: function ($that) {
      var descContent = $that.nodes.$ProductOverviewDesc.html() || '';
      var $descWrapper = $that.nodes.$descReadMore.closest('.js-desc-wrapper');
      var minCharlength = this.isMobile 
      ? 
        Drupal.settings.globals_variables.po_character_count_mobile ? Drupal.settings.globals_variables.po_character_count_mobile : 239 
      :
        Drupal.settings.globals_variables.po_character_count_desktop ? Drupal.settings.globals_variables.po_character_count_desktop : 316;

      if (descContent.length > minCharlength) {
        var descContentShortened = descContent.slice(0, minCharlength);

        $that.nodes.$ProductOverviewDesc.html(descContentShortened + '...');
        $that.nodes.$descReadMore.once().on('click', function () {
          $descWrapper.toggleClass('desc-expanded');
          if ($descWrapper.hasClass('desc-expanded')) {
            $that.nodes.$ProductOverviewDesc.html(descContent);
          } else {
            $that.nodes.$ProductOverviewDesc.html(descContentShortened + '...');
          }
        });
      } else {
        $descWrapper.removeClass('desc-expanded').addClass('no-read-more');
        $that.nodes.$descReadMore.addClass('hidden');
      }
    },

    attached: false
  };
})(jQuery);
